module.exports = __webpack_public_path__ + "static/img/cz.a0d8f852.png";